export const mezzoLightsValues = ['off', 'low', 'medium', 'high']
export const mezzoLightsOffValue = 0
export const mezzoLightsMaxValue = 3
